<template>
  <div class="audio">
    <div class="audio-wrap" v-if="imgListType==0" :style="audioBgImgStyle">
      <div class="audio-cover">
        <img @click="bgMusicPlayOrPause" :src="audioCover" alt />
      </div>
      <div class="audio-hotarea" @click="handleHotarea"></div>
    </div>
    <div v-else-if="imgListType==1" class="audio-other" :class="'location'+location" :style="audioBgImgStyle">
      <div @click="leftAreaClick" v-if="'location'+location=='location2'||'location'+location=='location3'"
        class="left-area"></div>
      <div class="record-wrap">
        <div :class="playFlag?'play':'pause'" class="audio-point">
          <img :src="pointUrl" alt />
        </div>
        <div class="record-plate">
          <img :src="pauseBtnImgSrc" @click="bgMusicPlayOrPause" v-show="playFlag" />
          <img :src="playBtnImgSrc" @click="bgMusicPlayOrPause" v-show="!playFlag" />
          <div class="plate" :class="playFlag?'play':'play pause'">
            <div class="level-1 pos-center">
              <div class="level-2 pos-center">
                <div class="level-3 pos-center">
                  <div class="level-4 pos-center">
                    <div class="level-5 pos-center">
                      <div class="level-6 pos-center">
                        <div class="record-cover pos-center">
                          <img :src="audioCover" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="rightAreaClick" v-if="'location'+location=='location2'||'location'+location=='location1'"
        class="right-area"></div>
    </div>
    <div v-if="imgListType==2" class="three_audio_style" :style="flexAudioStyle">
      <img @click="bgMusicPlayOrPause" :src="audioCover" alt />
    </div>
    <audio id="audio-tag" loop ref="audio" :src="info.props.imgList[info.imgListType].audioUrl" preload="auto">您的浏览器不支持
      audio 标签。</audio>
  </div>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
export default {
  name: "Audio",
  props: {
    info: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      imgListType: 0, //所属类型
      imgList: [], //存储的audio信息
      audioSource: "", //音频资源地址
      playFlag: false, //播放的状态 true是播放，false是暂停
      location: "right", //胶盘的位置
      playBtnImgSrc: "", //播放按钮的图片
      pauseBtnImgSrc: "", //暂停按钮的图片
      pointUrl: "", //指针图片url
      clickMusicBtn: false
    };
  },
  inject: ['getEnterSource'],
  computed: {
    enterSource() {
      return this.getEnterSource();
    },
    audioCover() {
      if (this.imgListType == 1) {
        return this.info.props.imgList[this.info.imgListType].playUrl;
      }
      return this.playFlag
        ? this.info.props.imgList[this.info.imgListType].playUrl
        : this.info.props.imgList[this.info.imgListType].stopUrl;
    },
    audioBgImgStyle() {
      return {
        background: `url(${this.info.props.imgList[this.info.imgListType].backgroundImg
          }) center center no-repeat`
      };
    },
    flexAudioStyle() {
      let obj = {
        width: this.info.props.imgList[this.info.imgListType].width + 'px',
        height: this.info.props.imgList[this.info.imgListType].height + 'px',
        position: 'fixed',
      }
      obj[this.info.props.imgList[this.info.imgListType].upAndDown] = this.info.props.imgList[this.info.imgListType].upAndDownValue + 'px'
      obj[this.info.props.imgList[this.info.imgListType].leftAndRight] = this.info.props.imgList[this.info.imgListType].leftAndRightValue + 'px'
      return obj
    }
  },
  created() { },
  mounted() {
    this.formatData().then(() => {
      // this.audioPlayer();
      this.addEventListenerPage();
    });
    // 自动播放
    if (this.info.props.imgList[this.info.imgListType].ifAutoPlay) {
      this.bgMusicPlayOrPause()
    }
  },
  methods: {
    formatData() {
      return new Promise((resolve, reject) => {
        this.imgListType = this.info.imgListType;
        this.imgList = this.info.props.imgList;
        this.playBtnImgSrc = this.imgList[this.imgListType].playBtnUrl || "";
        this.pauseBtnImgSrc = this.imgList[this.imgListType].stopBtnUrl || "";
        this.pointUrl = this.imgList[this.imgListType].pointUrl || "";
        this.location = this.imgList[this.imgListType].location || 1;
        this.audioSource = this.imgList[this.imgListType].audioUrl || ""
        resolve();
      });
    },
    addEventListenerPage() {
      document.addEventListener("visibilitychange", e => {
        // 兼容ios微信手Q
        // console.log('document.hidden---->',document.hidden)
        if (document.hidden) {
          // 网页被挂起
          this.audioPause();
          this.playFlag = false;
        } else {
          if (this.clickMusicBtn) {
            // 点击了关闭音乐按钮
            this.audioPlayer();
            this.playFlag = true;
          } else {
            this.audioPause();
            this.playFlag = false;
          }
        }
      });
    },
    bgMusicPlayOrPause() {
      this.clickMusicBtn = !this.clickMusicBtn;
      if (this.playFlag) {
        this.audioPause();
        this.playFlag = false;
      } else {
        this.audioAutoPlay();
        this.playFlag = true;
      }
      this.$log.senLog({
        pointID: '12010003',
        eventType: 2,
        businessData: {
          activityType: this.activityType !== undefined ? this.activityType : '',
          activityId: this.activityId || '',
          url: this.audioSource || '',
          appSource: isMiniApplets() ? isMiniApplets() : '',
          enterSource: this.enterSource || '',
        }
      })
    },
    audioPause() {
      let audio = this.$refs.audio;
      audio.pause();
      this.playFlag = false;
      // console.log('音乐停止-------》')
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          audio.pause();
          this.playFlag = false;
        },
        false
      );
      document.addEventListener(
        "YixinJSBridgeReady",
        () => {
          audio.pause();
          this.playFlag = false;
        },
        false
      );
    },
    audioAutoPlay() {
      let audio = this.$refs.audio;
      audio.play();
      this.playFlag = true;
      // console.log('音乐播放-------》')
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          audio.play();
          this.playFlag = true;
        },
        false
      );
      document.addEventListener(
        "YixinJSBridgeReady",
        () => {
          audio.play();
          this.playFlag = true;
        },
        false
      );
    },
    audioPlayer() {
      console.log("audioPlayer");
      let audio = this.$refs.audio;
      // console.log('音乐播放.....audioPlayer.....')
      audio.addEventListener("canplay", () => {
        // console.log('音乐可以播放..........')
        // audio.play()
        this.audioAutoPlay(true);
      });
      // // console.log('audio---->',audio)
      if (isMiniApplets() == "wechat") {
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => {
            // audio.play()
            this.audioAutoPlay(true);
            // this.$store.dispatch('setMusiceSwitch',true);
          },
          false
        );
        // 添加 getNetworkType 的判断原因, 请看问题分析2
        if (
          typeof window.WeixinJSBridge == "object" &&
          typeof window.WeixinJSBridge.invoke == "function"
        ) {
          window.WeixinJSBridge.invoke("getNetworkType", {}, () => {
            // audio.play()
            this.audioAutoPlay(true);
            // this.$store.dispatch('setMusiceSwitch',true);
          });
        }
      } else {
        // audio.play()
        // this.$store.dispatch('setMusiceSwitch',true);
        this.audioAutoPlay(true);
        let touchPlay = () => {
          // audio.play()
          this.audioAutoPlay(true);
          // this.$store.dispatch('setMusiceSwitch',true);
          document.removeEventListener("touchstart", touchPlay, false);
        };
        document.addEventListener("YixinJSBridgeReady", touchPlay, false);
        if (audio.paused) {
          document.addEventListener("touchstart", touchPlay, false);
        }
      }
    },

    // 左边热区点击
    leftAreaClick() {
      this.$emit("handleAudioClick", this.imgList[this.imgListType]);
      // this.urlFor(this.imgList[this.imgListType]);
    },
    // 右边热区点击
    rightAreaClick() {
      this.$emit("handleAudioClick", this.imgList[this.imgListType]);
      // this.urlFor(this.imgList[this.imgListType]);
    },

    handleHotarea() {
      this.$emit("handleAudioClick", this.imgList[this.imgListType]);
      // this.urlFor(this.imgList[this.imgListType]);
    }
    // isWeixin() {
    //   let ua = window.navigator.userAgent.toLowerCase();
    //   return /micromessenger/.test(ua);
    // }
  }
};
</script>

<style scoped lang="scss">
.audio-other,
.audio-wrap {
  box-sizing: border-box;
  background-repeat: no-repeat;
  display: flex;
  background-size: 100% 100% !important;
}

.audio-wrap {
  height: 202px;
  padding: 37px;
  display: flex;
  background-size: 100% 100% !important;
  background: #ccc;

  .audio-cover {
    width: 126px;
    overflow: hidden;
    height: 126px;
    margin-right: 20px;
    border-radius: 10px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      font-size: 80px;
      color: #fff;
    }
  }

  .audio-hotarea {
    flex: 1;
  }
}

.audio-other {
  height: 520px;
  position: relative;

  .left-area,
  .right-area {
    flex: 1;
  }

  &.location1 {
    justify-content: flex-start;
  }

  &.location2 {
    justify-content: center;
  }

  &.location3 {
    justify-content: flex-end;
  }

  .record-wrap {
    position: relative;
    width: 50%;

    .record-plate {
      position: absolute;
      top: 145px;
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: center;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 3;
        width: 120px;
        height: 120px;
      }

      .plate {
        width: 350px;
        height: 350px;
        background: linear-gradient(#030305, #313033, #030305);
        // border: 1px solid #030305;
        border-radius: 50%;
        transform-origin: center center;

        &.play {
          animation: zhuan 2.8s infinite linear forwards;
        }

        &.pause {
          animation-play-state: paused;
        }
      }

      .pos-center {
        border-radius: 50%;
        // border: 1px solid #2c2e34;
        position: relative;
        // border:none;
        box-shadow: inset 0px -1px 1px -1px #b5b3bd;
      }

      .level-1 {
        width: 95%;
        height: 95%;
      }

      .level-2 {
        width: 95%;
        height: 95%;
      }

      .level-3 {
        width: 94%;
        height: 94%;
      }

      .level-4 {
        width: 93%;
        height: 93%;
      }

      .level-5 {
        width: 93%;
        height: 93%;
      }

      .level-6 {
        width: 93%;
        height: 93%;
      }
    }

    .record-cover {
      width: 220px;
      height: 220px;
      background: linear-gradient(#646366, #313033, #030305);
      border-radius: 50%;
      overflow: hidden;

      img {
        border-radius: 50%;
        overflow: hidden;
        width: 100%;
        height: 100%;
      }
    }
  }

  .audio-point {
    position: absolute;
    left: 42%;
    width: 200px;
    transform-origin: 0 0;

    &.play {
      animation: play 0.3s linear forwards;
    }

    &.pause {
      animation: pause 0.3s linear forwards;
    }

    z-index: 2;

    img {
      width: 100%;
    }
  }
}

@keyframes pause {
  from {
    transform: rotate(24deg);
  }

  to {
    transform: rotate(8deg);
  }
}

@keyframes play {
  from {
    transform: rotate(8deg);
  }

  to {
    transform: rotate(24deg);
  }
}

@keyframes zhuan {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

#audio-tag {
  display: none;
}

.three_audio_style {
  z-index: 999;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>